// @ts-strict-ignore
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'appFilter',
    standalone: false
})
export class FilterPipe implements PipeTransform {
  transform(searchArray, searchText, language?): any {
    let result = [];
    if (!searchText && language) {
      return [];
    }

    if (!searchText && !language) {
      return searchArray;
    }

    searchText = searchText.toLocaleLowerCase();

    searchArray.filter((item) => {
      if (language && item[language]) {
        return item[language].toLocaleLowerCase().includes(searchText) ? result.push(item) : null;
      } else if (!language && !item[language]) {
        return item.name.toLocaleLowerCase().includes(searchText) ? result.push(item) : null;
      } else {
        return '';
      }
    });

    return result;
  }
}
